module.exports = __webpack_public_path__ + "img/close-red.3b0332f8.svg";